// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.errPage-container[data-v-0fdd3898] {\n  padding: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
